import type { ReactNode } from 'react';
import { ModuleSectionLayout } from './ModuleSectionLayout';

interface OperationsLayoutProps {
  title: string;
  description: string;
  moduleLabel?: string;
  children: ReactNode;
}

export function OperationsLayout({ title, description, moduleLabel, children }: OperationsLayoutProps) {
  return (
    <ModuleSectionLayout
      section="Operations"
      title={title}
      description={description}
      moduleLabel={moduleLabel}
    >
      {children}
    </ModuleSectionLayout>
  );
}
